import React, { useState } from "react";
import { Modal, Button, Card, Container, Row, Col } from "react-bootstrap";
import "./Broadcastlist.css";
import pdf1 from "../Assets/BroadcastPdfs/01a_Provider Burnout_by Microsoft.pdf";
import pdf2 from "../Assets/BroadcastPdfs/02a_Tracking healthcare data breaches.pdf";
import pdf3 from "../Assets/BroadcastPdfs/03_Low collection RCA_a quick recokner.pdf";
import img1 from "../Assets/BroadcastPdfs/01_PROVIDER BURNOUT.jpg";
import img2 from "../Assets/BroadcastPdfs/02_TRACKING DATA BREACH.png";
import img3 from "../Assets/BroadcastPdfs/03_LOW COLLECTION RCA.jpg";

const Broadcastlist = () => {
  const broadcasts = [
    {
      id: 1,
      category: "Provider Burnout_by Microsoft",
      description:
        "Violence. Under-staffing. Corporate consolidation. Poor work-life balance.It's no secret healthcare professionals have to grapple with difficult working conditions....",
      image: img1,
      pdf: pdf1,
    },
    {
      id: 2,
      category: "Tracking healthcare data breaches",
      description:
        "A breach at a revenue cycle management firm may have exposed the data of more than 361,000 people...",
      image: img2,
      pdf: pdf2,
    },
    {
      id: 3,
      category: "LOW COLLECTION RCA",

      description:
        "Find what percentage of claims are denied at the first submission. Anything above 5% means your denial management process has gaps and needs to be streamlined immediately...",
      image: img3,
      pdf: pdf3,
    },
  ];
  const [show, setShow] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState("");

  const handleShow = (pdf) => {
    setSelectedPdf(pdf);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <Container className="BroadcastsReader">
      <Row>
        {broadcasts.map((broadcast) => (
          <Col md={12} key={broadcast.id} className="mt-4 mb-4">
            <Card className="broadcast-card" style={{ paddingLeft: "0px" }}>
              <Row noGutters>
                <Col md={4} style={{ paddingLeft: "0px" }}>
                  <Card.Img
                    variant="top"
                    src={broadcast.image}
                    className="broadcast-image"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body style={{ padding: "20px" }}>
                    <span className=" read-more">{broadcast.category}</span>
                    <Card.Title className="broadcast-title">
                      {broadcast.title}
                    </Card.Title>
                    <Card.Text className="broadcast-description">
                      {broadcast.description}
                    </Card.Text>
                    <Button
                      variant="link"
                      className="category-label"
                      onClick={() => handleShow(broadcast.pdf)}
                      style={{ marginLeft: "-10px", textDecoration: "none" }}
                    >
                      Read more →
                    </Button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>

      {/* PDF Modal */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="">Myrtle Rcm's Document Viewer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src={selectedPdf}
            title="PDF Viewer"
            className="pdf-viewer"
          ></iframe>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Broadcastlist;
